
export default {
  name: 'AppIconAiGradation',
  props: {
    iconSize: { type: Number, default: 16 }
  },
  data() {
    const baseId = `app-icon-ai-gradation-${this._uid}`;
    return {
      ids: {
        paint0: `${baseId}-paint0`,
        paint1: `${baseId}-paint1`,
        paint2: `${baseId}-paint2`,
        paint3: `${baseId}-paint3`,
        paint4: `${baseId}-paint4`,
        clip: `${baseId}-clip`
      }
    };
  }
};
